// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  width: 100%;
  padding: 1rem 0.5rem;
  display: block;
  margin: 0 auto;
}

mat-card-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
mat-card-actions a {
  width: 100%;
  color: var(--text-color);
}
mat-card-actions button {
  margin: 0.5rem 0 0;
  width: 100%;
  background-color: var(--dim-white);
}

mat-card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
mat-card-header mat-card-title {
  position: relative;
  text-align: center;
  height: 2em;
  overflow: hidden;
}
mat-card-header mat-card-title:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 30%;
  height: 1em;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgb(255, 255, 255) 50%);
}`, "",{"version":3,"sources":["webpack://./src/app/components/ads/ad-card/ad-card.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,wBAAA;AACJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,kCAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AADJ;AAGI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,qFAAA;AADN","sourcesContent":["img {\r\n  width: 100%;\r\n  padding: 1rem 0.5rem;\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n\r\nmat-card-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n\r\n  a {\r\n    width: 100%;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  button {\r\n    margin: 0.5rem 0 0;\r\n    width: 100%;\r\n    background-color: var(--dim-white);\r\n  }\r\n}\r\n\r\nmat-card-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  mat-card-title {\r\n    position: relative;\r\n    text-align: center;\r\n    height: 2em;\r\n    overflow: hidden;\r\n\r\n    &:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      bottom: 0;\r\n      right: 0;\r\n      width: 30%;\r\n      height: 1em;\r\n      background: linear-gradient(\r\n        to right,\r\n        rgba(255, 255, 255, 0),\r\n        rgba(255, 255, 255, 1) 50%\r\n      );\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
